export const selectEdition = (state: RootState) => state.app.edition

export const selectInstallVersion = (state: RootState) => state.app.installVersion

export const selectGpuComputeCap = (state: RootState) => state.app.gpuComputeCap

export const selectExternalLoginUrl = (state: RootState) => state.app.externalLoginUrl

export const selectLogPath = (state: RootState) => state.app.logPath

export const selectLogsEnabled = (state: RootState) => state.app.logsEnabled

export const selectEnableLiveStreamCaptureAPI = (state: RootState) => state.app.enableLiveStreamCaptureAPI

export const selectImageOverlayMaxSize = (state: RootState) => state.app.imageOverlayMaxSize
